<template>
    <div>
      <div class="top">
        <!---->
        <div style="text-align: right">
          <span>当前用户：{{name}}</span>
          <div style="display: inline-block;cursor: pointer" @click="loginOut">
            <span>登出</span>
          </div>
        </div>
        <!--翻译-->
        <div style="text-align: right; margin-top: 10px">
          <!--<div v-for="item in translateBtn" v-bind:key="item.text" v-on:click="item.clickMethod" style="cursor: pointer; display: inline-block; text-align: center; margin-left: 20px">
            <span>{{item.text}}</span>
          </div>
          -->
          <div>
            <select v-model="currentSelectTranlate"  style="cursor: pointer; display: inline-block; text-align: center; margin-left: 20px; background-color: rgb(224, 95, 64); color: white; padding: 3px">
              <option v-for="item in translateBtn" v-bind:key="item.text" v-bind:value = "item.value">{{item.text}}</option>
            </select>
          </div>
        </div>
        <!--流程flow-->
        <div>
          <div id="block-flow">
            <ul class="flow">
              <li v-for="item in process" v-bind:key="item.text" v-bind:class="{active: item.isActive}">{{item.text}}</li>
            </ul>
          </div>
        </div>
      </div>
      <!--<div class="header">
        <span v-for="item in headerlist" v-bind:key="item.text">{{item.text}}</span>
      </div>-->
      <!--项目金额收据选择-->
      <div class="content_item">
        <div>
          <span class="content_title">{{notice}}</span>
        </div>
        <div>
          <div class="title_margin content_item_title" style="display: inline-block">
            <span class="content_title" v-html="usage"></span>
          </div>
        </div>
        <!--项目-->
        <div class="content_item_list content_margin">
          <div v-for="item in itemList" v-bind:key="item.key" style="margin-bottom: 10px; margin-right: 10px" v-bind:class="itemNameClass(item)" v-on:click="itemNameClick(item)" v-on:mouseenter="itemNameMouseEnter(item)" v-on:mouseleave="itemNameMouseLeave(item)">
            <span>{{item.text}}</span>
          </div>
        </div>
        <!--<div class="content_item_list content_margin">
          <select-check-box v-bind:dataList="itemList" v-bind:single-select-mode="true"/>
        </div>-->
        <div style="margin-top: 20px;">
          <span>{{itemNameNotice}}</span>
        </div>
        <!--金额标题-->
        <div class="title_margin">
          <span class="content_item_title content_title">{{moneyTitle}}</span>
        </div>
        <!--金额选择-->
        <div class="content_margin content_item_list ">
          <div v-for="item in quotaList" style="margin-bottom: 10px; margin-right: 10px" v-bind:key="item.text" v-bind:class="moneyClass(item)" v-on:mouseenter="moneyMouseEnter(item)" v-on:mouseleave="moneyMouseLeave(item)" v-on:click="moneyClick(item)">
            <span>{{item.text}}</span>
          </div>
        </div>
        <!--金额自定义-->
        <div class="title_margin" style="color: black">
          <span>{{moneyOtherTitle}}</span>
          <input type="number" class="input_item" style="width: 25%; margin-left: 10px" v-model="customMoney" v-on:blur="customInputBlur()" placeholder="(100-495000)"/>
          <span v-show="isShowCustomMoneyTip2" style="margin-left: 10px; font-size: 1em; color: rgb(224, 95, 64)">{{customMoneyTip2}}</span>
        </div>
        <!--收据-->
        <div class="title_margin" style="color: black">
          <span>{{receiptTitle}}</span>
          <label v-for="item in receiptList" v-bind:key="item.text" style="margin-left: 15px">
            <input type="radio" name="receipt" v-model="currentReceipt" v-bind:value="item.value">
            <span>{{item.text}}</span>
          </label>
        </div>
      </div>
      <!--详细信息填写-->
      <div class="content_item">
        <!--标题-->
        <div class="title_margin">
          <span class="content_item_title content_title">{{detailTitle}}</span>
        </div>
        <div>
          <div class="block_tip_detail">
            <span class="tip_mustfill">{{this.donateSelectTitle.text}}</span>
          </div>
          <div class="content_item_list content_margin">
            <div v-for="item in donateList" v-bind:key="item.value" v-bind:class="moneyClass(item)" style="margin-right: 10px" v-on:mouseenter="moneyMouseEnter(item)" v-on:mouseleave="selectMouseLeave(item)" v-on:click="donateSelect(item)"><span>{{item.text}}</span></div>
          </div>
        </div>
        <!--我已是捐款者-->
        <div v-if="isNewDonate">
          <div class="title_margin" style="display: flex">
            <input class="input_item" type="text" v-bind:class="['input_item', donationNumberDetail.mclass]" v-bind:placeholder="donationNumberDetail.mholder" style="width: 100%;" v-model="donationNumberDetail.mvalue" v-on:blur="checkInputVaild(donationNumberDetail)">
          </div>
        </div>
        <!--我是新的捐款者-->
        <div v-else>
          <div class="block_tip_detail">
            <div v-for="item in detailTip" v-bind:key="item.text" style="margin-top: 6px" v-show="item.isShow">
              <span v-bind:class="item.mclass">{{item.text}}</span>
            </div>
          </div>
          <!--企业机构名称-->
          <div class="title_margin" style="display: flex">
            <input class="input_item" type="text" v-bind:placeholder="companyDetail.mholder" style="width: 100%;" v-model="companyDetail.mvalue">
          </div>
          <!--名称-->
          <div class="content_margin" style="display: flex">
            <input class="input_item" type="text" v-bind:class="['input_item', nameDetail.mclass]" v-bind:placeholder="nameDetail.mholder" style="width: 100%;" v-model="nameDetail.mvalue" v-on:blur="checkInputVaild(nameDetail)">
          </div>
          <!--电话号码,电邮地址-->
          <div class="content_margin" style="display: flex;">
            <input type="text" v-bind:class="['input_item', phoneDetail.mclass]" v-bind:placeholder="phoneDetail.mholder" style="width: 100%;" v-model="phoneDetail.mvalue" v-on:blur="checkInputVaild(phoneDetail)">
            <input type="text" v-bind:class="['input_item', phoneAddressDetail.mclass]" v-bind:placeholder="phoneAddressDetail.mholder" style="width: 100%; margin-left: 10px" v-model="email" v-on:blur="checckInputEmail(phoneAddressDetail)">
          </div>
          <!--地址-->
          <div class="content_margin" style="display: flex">
            <input type="text" v-bind:class="['input_item', addressDetail.mclass]" v-bind:placeholder="addressDetail.mholder" v-model="addressDetail.mvalue" style="width: 100%;" v-on:blur="checkInputVaild(addressDetail)">
          </div>
          <div v-if="false">
            <!--注册号码/地-->
            <div class="content_margin" style="display: flex">
              <input class="input_item input_overseas" type="text" v-bind:placeholder="registerNumberDetail.mholder" v-model="registerNumberDetail.mvalue" style="width: 100%;">
              <input class="input_item input_overseas" type="text" v-bind:placeholder="registerPlaceDetail.mholder" v-model="registerPlaceDetail.mvalue" style="width: 100%; margin-left: 10px">
            </div>
            <!--注册日期/签名-->
            <div class="content_margin" style="display: flex">
              <input class="input_item input_overseas" type="text" v-bind:placeholder="registerDateDetail.mholder" v-model="registerDateDetail.mvalue" style="width: 100%;">
              <input class="input_item input_overseas" type="text" v-bind:placeholder="registerSignDetail.mholder" v-model="registerSignDetail.mvalue" style="width: 100%; margin-left: 10px">
            </div>
            <!--国籍/护照号码-->
            <div class="content_margin" style="display: flex">
              <input class="input_item input_overseas" type="text" v-bind:placeholder="countryDetail.mholder" v-model="countryDetail.mvalue" style="width: 100%;">
              <input class="input_item input_overseas" type="text" v-bind:placeholder="passNumberDetail.mholder" v-model="passNumberDetail.mvalue" style="width: 100%; margin-left: 10px">
            </div>
            <!--护照出发日期/失效日期-->
            <div class="content_margin" style="display: flex">
              <input class="input_item input_overseas" type="text" v-bind:placeholder="passGooffDetail.mholder" v-model="passGooffDetail.mvalue" style="width: 100%;">
              <input class="input_item input_overseas" type="text" v-bind:placeholder="passExpiryDetail.mholder" v-model="passExpiryDetail.mvalue" style="width: 100%; margin-left: 10px">
            </div>
          </div>
        </div>
      </div>
      <!--下一步按钮-->
      <div class="content_margin content_pay_item" style="display: flex; justify-content: center; margin-bottom: 20px;" v-on:click="jumpToStep()" >
        <span class="content_next_item_text">{{nextStepBtn}}</span>
      </div>
    </div>
</template>

<script>
import {getInformation, getItemList, getLangJsonBody, getResponse} from '@/api'
import '@/ext'
import SelectCheckBox from '@/components/SelectCheckBox'

export default {
  name: 'DonationIndex',
  components: {SelectCheckBox},
  data () {
    return {
      lang: 'zh_TW',
      headerlist: [
        {text: '捐款项目'},
        {text: '捐款总结'},
        {text: '捐款中'},
        {text: '捐款完成'}
      ],
      project: null,
      itemNameNotice: null,
      currentSelectTranlate: 'zh_TW',
      translateBtn: [
        {text: 'ZH', clickMethod: this.translateToZh, value: 'zh_TW'},
        {text: 'EN', clickMethod: this.translateToEn, value: 'en'}
      ],
      itemList: [
        {text: '恩慈教育基金會', isSelect: null, value: null},
        {text: '路向四肢傷殘人士協會', isSelect: null, value: null}
      ],
      quotaList: [
        {text: '港幣$100元', money: 100, isSelect: null},
        {text: '港幣$500元', money: 500, isSelect: null},
        {text: '港幣$1000元', money: 1000, isSelect: null},
        {text: '港幣$5000元', money: 5000, isSelect: null},
        {text: '港幣$10000元', money: 10000, isSelect: null}
      ],
      receiptList: [
        {text: '是(請給我中文收據)', value: 1},
        {text: '是(請給我英文收據)', value: 2},
        {text: '否', value: 0}
      ],
      donateList: [
        {text: '是', value: 1, isSelect: true},
        {text: '否', value: 0, isSelect: null}
      ],
      currentItem: null,
      notice: '本人現捐款支持香港紅十字會服務',
      usage: '捐款用途*',
      moneyTitle: '單次捐款金額*',
      moneyOtherTitle: '其他金額 港幣HK$',
      currentReceipt: null,
      lastSelectMoneyItem: null, // 一个quotaList的对象
      currentDonate: null,
      hasSelectNameItemList: [],
      currentMoney: null,
      customMoney: null,
      customMoneyTip: '作網上捐款，請輸入港幣500,000或以下的捐款金額',
      customMoneyTip2: '金額不得超過500,000',
      isShowCustomMoneyTip2: false,
      receiptTitle: '是否需要捐款收據:',
      caddressDetailurrentReceipt: null,
      detailTitle: '捐款者資料',
      refundTip: null, // 不可退款提示
      verfication: null, // 手机验证码文本
      captcha: null,
      companyDetail: {
        mholder: '機構/企業名稱',
        mvalue: null
      },
      nameDetail: {
        mholder: '名稱:',
        mvalue: null,
        mclass: 'input_error'
      },
      phoneDetail: {
        mholder: '電話号码:',
        mvalue: null,
        mclass: 'input_error'
      },
      phoneAddressDetail: {
        mholder: '电邮地址:',
        mvalue: null,
        mclass: 'input_error'
      },
      addressDetail: {
        mholder: '地址:',
        mvalue: null,
        mclass: 'input_error'
      },
      registerNumberDetail: {
        mholder: '注册號碼(如機構或企業):',
        mvalue: null
      },
      registerPlaceDetail: {
        mholder: '注册地(如機構或企業):',
        mvalue: null
      },
      registerDateDetail: {
        mholder: '注册日期(如機構或企業):',
        mvalue: null
      },
      registerSignDetail: {
        mholder: '授權簽字人(如機構或企業):',
        mvalue: null
      },
      countryDetail: {
        mholder: '國籍(只僅非香港捐款者填寫):',
        mvalue: null
      },
      passNumberDetail: {
        mholder: '護照號碼(只僅非香港捐款者填寫):',
        mvalue: null
      },
      passGooffDetail: {
        mholder: '護照發出日期(只僅非香港捐款者填寫):',
        mvalue: null
      },
      passExpiryDetail: {
        mholder: '護照失效日期(只僅非香港捐款者填寫):',
        mvalue: null
      },
      donationNumberDetail: {
        mholder: '捐款者編號',
        mvalue: null,
        mclass: 'input_error'
      },
      emailValue: null,
      itemNameAlterTip: '请至少选择一项项目',
      moneyAlterTip: '请至少选择一个金额',
      moneyValueAlterTip: '自定金额必须在100-500000内',
      receiptAlterTip: '请至少选择一个发票类型',
      nameAlterTip: '请填写名称',
      companyAlterTip: '請填寫機構/企業名稱',
      phoneNumberAlterTip: '请填写电话号码',
      emailAlterTip: '请填写電郵地址',
      addressAlterTip: '请填写地址',
      addressFormatAlterTip: '请填写正确的邮箱地址',
      detailTip: [
        {text: '本頁面的信息必須與捐款銀行卡信息一致', mclass: 'tip_overseas', isShow: true},
        {text: '紅框為必須填寫事項', mclass: 'tip_mustfill', isShow: true},
        {text: '藍框為海外捐款人或機構填寫事項', mclass: 'tip_overseas', isShow: false}
      ],
      nextStepBtn: '下一步',
      resultTitle: null,
      resultTitleDetail: null,
      donationBtn: null,
      unionTip: null,
      process: [
        {text: '捐款项目', isActive: true},
        {text: '捐款总结', isActive: false},
        {text: '捐款中', isActive: false},
        {text: '捐款完成', isActive: false}
      ],
      isNewDonation: false,
      donateSelectTitle: {
        text: '您是現有捐款者？'
      },
      loadingTip: null,
      wechatDialogTitle: '支持wechat HK支付',
      name: null
    }
  },
  methods: {
    loginOut () {
      this.$cookies.remove('token')
      this.$router.push({name: 'login'})
    },
    async jumpToStep () {
      if (this.checkAllRequestParams()) {
        let company = this.companyDetail
        let name = this.nameDetail
        let address = this.addressDetail
        let phone = this.phoneDetail
        let email = this.phoneAddressDetail
        let registerNumber = this.registerNumberDetail
        let registerPlace = this.registerPlaceDetail
        let registerDate = this.makeRegisterDate()
        let registerSign = this.registerSignDetail
        let country = this.countryDetail
        let passNumber = this.passNumberDetail
        let passGoof = this.makeGooffDate()
        let passExpiry = this.makeExpiryDate()
        let jumpParams = {
          itemList: this.makeItemListToParams(),
          money: this.makeCurrentMoney(),
          receipt: this.makeReceipt(),
          name: name,
          company: company,
          phoneNumber: phone,
          phoneAddress: email,
          address: address,
          registerNumber: registerNumber,
          registerPlace: registerPlace,
          registerDate: registerDate,
          registerSign: registerSign,
          country: country,
          passNumber: passNumber,
          passGooff: passGoof,
          passExpiry: passExpiry,
          unionTip: this.unionTip,
          resultTitle: this.resultTitle,
          resultTitleDetail: this.resultTitleDetail,
          donationBtn: this.donationBtn,
          process: this.process,
          loadingTip: this.loadingTip,
          donationNumber: this.donationNumberDetail.mvalue,
          wechatDialogTitle: this.wechatDialogTitle,
          local: this.lang,
          refundTip: this.refundTip,
          verfication: this.verfication,
          verficationTip: this.verficationTip,
          captcha: this.captcha
        }
        if (this.isNewDonate) {
          let requestParams = {
            api_token: this.$cookies.get('token'),
            key: this.donationNumberDetail.mvalue
          }
          getResponse(getInformation(requestParams), resData => {
            let data = resData.data.info
            console.log('获取information结果', resData)
            company.mvalue = data.company
            name.mvalue = data.name
            phone.mvalue = data.phone
            address.mvalue = data.address
            email.mvalue = data.email
            registerNumber.mvalue = data.register_no
            registerPlace.mvalue = data.register_country
            registerDate.mvalue = data.register_date
            registerSign.mvalue = data.auth_name
            country.mvalue = data.region
            passNumber.mvalue = data.passport_no
            passGoof.mvalue = data.passport_start_date
            passExpiry.mvalue = data.passport_end_date
            this.$router.replace({
              name: 'steptwo',
              params: jumpParams
            })
          })
        } else {
          this.$router.replace({
            name: 'steptwo',
            params: jumpParams
          })
        }
      }
    },
    checkAllRequestParams: function () {
      // 检查所有必要参数
      if (this.hasSelectNameItemList.length === 0) {
        alert(this.itemNameAlterTip)
        return false
      }
      if (this.makeCurrentMoney() == null) {
        alert(this.moneyAlterTip)
        return false
      } else if ((this.customMoney != null && this.customMoney.trim() !== '') && (this.makeCurrentMoney().value < 100 || this.makeCurrentMoney().value > 495000)) {
        alert(this.moneyValueAlterTip)
        return false
      }
      if (this.currentReceipt == null) {
        alert(this.receiptAlterTip)
        return false
      }
      if (this.isNewDonate) {
        if (this.donationNumberDetail.mvalue == null || this.donationNumberDetail.mvalue.trim() === '') {
          alert('请填写捐款者编号')
          return false
        }
      } else {
        if (this.nameDetail.mvalue == null || this.nameDetail.mvalue.trim() === '') {
          alert(this.nameAlterTip)
          return false
        }
        if (this.phoneDetail.mvalue == null || this.phoneDetail.mvalue.trim() === '') {
          alert(this.phoneNumberAlterTip)
          return false
        }
        if (this.phoneAddressDetail.mvalue == null || this.phoneAddressDetail.mvalue.trim() === '') {
          alert(this.emailAlterTip)
          return false
        }
        if (this.addressDetail.mvalue == null || this.addressDetail.mvalue.trim() === '') {
          alert(this.addressAlterTip)
          return false
        }
      }
      return true
    },
    makeCurrentMoney: function () {
      let temp = null
      if (this.currentMoney != null) {
        temp = this.currentMoney
      } else if (this.customMoney != null && this.customMoney.trim() !== '') {
        temp = this.customMoney
      }
      if (temp != null) {
        return {text: 'HK$' + temp, value: temp, title: this.moneyTitle + ':'}
      } else {
        return null
      }
    },
    makeItemListToParams: function () {
      let temp = []
      let valueArray = []
      for (let index = 0; index < this.hasSelectNameItemList.length; index++) {
        temp.push(this.hasSelectNameItemList[index].text)
      }
      for (let index = 0; index < this.hasSelectNameItemList.length; index++) {
        valueArray.push(this.hasSelectNameItemList[index].value)
      }
      return {mvalue: valueArray, title: this.usage + ':', mtitle: temp.toString()}
    },
    makeReceipt: function () {
      let temp = null
      for (let index in this.receiptList) {
        if (this.currentReceipt === this.receiptList[index].value) {
          temp = this.receiptList[index]
        }
      }
      return {mvalue: temp, title: this.receiptTitle + ':'}
    },
    makeRegisterDate: function () {
      return this.makeHolderToResult(this.registerDateDetail)
    },
    makeGooffDate: function () {
      return this.makeHolderToResult(this.passGooffDetail)
    },
    makeExpiryDate: function () {
      return this.makeHolderToResult(this.passExpiryDetail)
    },
    makeHolderToResult: function (item) {
      let temp = item.mholder
      let array = temp.split(':')
      let result = array[0] + ':'
      return {mholder: result, mvalue: item.mvalue}
    },
    getItemList: function () {
      // 获取项目列表
      let params = {
        api_token: this.$cookies.get('token')
      }
      getItemList(params).then(res => {
        this.project = res.data.data.projects
        for (let index in this.project) {
          this.itemList.push({text: this.project[index][this.lang], isSelect: null, value: index})
        }
        this.initSelectParams()
      })
    },
    moneyMouseEnter: function (item) {
      // 实现鼠标移进变色效果
      item.isSelect = true
    },
    itemNameMouseEnter: function (item) {
      item.isSelect = true
    },
    itemNameMouseLeave: function (item) {
      if (!this.hasSelectNameItemList.contain(item)) {
        item.isSelect = false
      }
    },
    itemNameClick: function (item) {
      this.addToSelectList(item)
    },
    addToSelectList: function (item) {
      // 多选 加入结果列表
      // 若有则清除结果列表里，并将其状态改为未选
      console.log('addToSelectList')
      let index = this.hasSelectNameItemList.indexOf(item)
      if (index > -1) {
        // 大于-1代表包含此元素，表示已被选择
        item.isSelect = false
        this.hasSelectNameItemList.splice(index, 1)
      } else {
        item.isSelect = true
        this.hasSelectNameItemList.push(item)
      }
    },
    moneyMouseLeave: function (item) {
      // 实现鼠标移出变色效果
      this.singleSelectMouseLeave(item, this.lastSelectMoneyItem)
    },
    selectMouseLeave: function (item) {
      this.singleSelectMouseLeave(item, this.currentDonate)
    },
    singleSelectMouseLeave: function (item, last) {
      if (item !== last) {
        item.isSelect = false
      }
    },
    donateSelect: function (item) {
      if (this.currentDonate != null) {
        this.currentDonate.isSelect = false
      }
      item.isSelect = true
      this.currentDonate = item
    },
    customInputBlur: function () {
      this.isShowCustomMoneyTip2 = false
    },
    moneyClick: function (item) {
      if (this.lastSelectMoneyItem != null) {
        this.lastSelectMoneyItem.isSelect = false
      }
      item.isSelect = true
      this.lastSelectMoneyItem = item
      this.currentMoney = item.money
      this.customMoney = null
    },
    checkInputVaild: function (item) {
      // 检查detail input是否为空
      let mvalue = item.mvalue
      if (mvalue == null || mvalue.trim() === '') {
        item.mclass = 'input_error'
      } else {
        item.mclass = 'input_noerror'
      }
    },
    checckInputEmail: function (item) {
      let reg = new RegExp('[\\w!#$%&\'*+/=?^_`{|}~-]+(?:\\.[\\w!#$%&\'*+/=?^_`{|}~-]+)*@(?:[\\w](?:[\\w-]*[\\w])?\\.)+[\\w](?:[\\w-]*[\\w])?')
      let result = reg.test(item.mvalue)
      if (result) {
        item.mclass = 'input_noerror'
      } else {
        item.mclass = 'input_error'
        alert(this.addressFormatAlterTip)
      }
    },
    translate: function () {
      console.log('当前语言', this.lang)
      if (this.lang === 'zh_TW') {
        getLangJsonBody('static/zh_TW').then(res => {
          console.log(res.data)
          this.replaceAllText(res.data)
        })
      } else {
        getLangJsonBody('static/en').then(res => {
          console.log(res.data)
          this.replaceAllText(res.data)
        })
      }
    },
    translateToZh: function () {
      this.lang = 'zh_TW'
      this.translate()
    },
    translateToEn: function () {
      this.lang = 'en'
      this.translate()
    },
    replaceAllText: function (data) {
      for (let index in this.quotaList) {
        this.quotaList[index].text = data.money[index].text
      }
      this.itemList = []
      this.hasSelectNameItemList = []
      this.getItemList()
      for (let index in this.receiptList) {
        this.receiptList[index].text = data.receipt[index].text
      }
      for (let index in this.detailTip) {
        this.detailTip[index].text = data.detailTip[index].text
      }
      for (let index in this.process) {
        this.process[index].text = data.process[index].text
      }
      this.notice = data.notice.text
      this.usage = data.usage.text
      this.moneyTitle = data.moneyTitle.text
      this.moneyOtherTitle = data.customMoneyTitle.text
      this.customMoneyTip2 = data.customMoneyTip.text
      this.receiptTitle = data.receiptTitle.text
      this.detailTitle = data.detailTitle.text
      this.nameDetail.mholder = data.name.text
      this.companyDetail.mholder = data.mycompany.text
      this.phoneDetail.mholder = data.phone.text
      this.phoneAddressDetail.mholder = data.email.text
      this.addressDetail.mholder = data.address.text
      this.registerNumberDetail.mholder = data.registerNumber.text
      this.registerPlaceDetail.mholder = data.registerPlace.text
      this.registerDateDetail.mholder = data.registerDate.text
      this.registerSignDetail.mholder = data.registerSign.text
      this.countryDetail.mholder = data.country.text
      this.passNumberDetail.mholder = data.passNumber.text
      this.passGooffDetail.mholder = data.passGooff.text
      this.passExpiryDetail.mholder = data.passExpiry.text
      this.itemNameAlterTip = data.itemNameTip.text
      this.moneyAlterTip = data.moneyTip.text
      this.receiptAlterTip = data.receiptTip.text
      this.nameAlterTip = data.nameTip.text
      this.phoneNumberAlterTip = data.phoneNumberTip.text
      this.emailAlterTip = data.emailEnterTip.text
      this.addressAlterTip = data.addressTip.text
      this.addressFormatAlterTip = data.addressFormatTip.text
      this.nextStepBtn = data.nextBtn.text
      this.itemNameNotice = data.itemNameNotice.text
      this.resultTitle = data.resultTitle
      this.resultTitleDetail = data.resultTitleDetail
      this.donationBtn = data.donationBtn
      this.donationNumberDetail.mholder = data.donationNumberDetail.text
      this.donateSelectTitle.text = data.donationSelect.text
      this.donateList[0].text = data.donationSelect.yes
      this.donateList[1].text = data.donationSelect.no
      this.companyAlterTip = data.companyTip.text
      this.loadingTip = data.loadingTip.text
      this.unionTip = data.unionTip.text
      this.wechatDialogTitle = data.wechatDialogTitle.text
      this.moneyValueAlterTip = data.customMoneyTip.text
      this.refundTip = data.refundTip.text
      this.verfication = data.verfication
      this.captcha = data.captcha
      console.log('data captcha', data.captcha)
    },
    updateCurrentLang () {
      console.log('params:', this.$route.query.lang, 'has', this.$route.query.hasOwnProperty('lang'))
      if (this.$route.query.hasOwnProperty('lang')) {
        this.lang = this.$route.query.lang
      }
    },
    initSelectParams: function () {
      if (this.$route.params.backparams === undefined || this.$route.params.backparams === null) {
        return
      }
      console.log('回传参数', this.$route.params.backparams)
      let selectItem = this.$route.params.backparams.itemList.mvalue
      for (let index in this.itemList) {
        for (let i in selectItem) {
          if (this.itemList[index].text === selectItem[i]) {
            this.addToSelectList(this.itemList[index])
          }
        }
      }
    },
    initMoneyParams: function () {
      let isCustomMoney = true
      for (let index in this.quotaList) {
        if (this.quotaList[index].money === this.$route.params.backparams.money.value) {
          this.moneyClick(this.quotaList[index])
          console.log('back params 金额选择', this.quotaList[index])
          isCustomMoney = false
        }
      }
      if (isCustomMoney) {
        this.customMoney = this.$route.params.backparams.money.value
      }
    },
    initReceipt: function () {
      for (let index in this.receiptList) {
        console.log('receipt compare params: ', this.$route.params.backparams.receipt.mvalue.value, 'list ', this.receiptList[index].value)
        if (this.receiptList[index].value === this.$route.params.backparams.receipt.mvalue.value) {
          this.currentReceipt = this.$route.params.backparams.receipt.mvalue.value
        }
      }
    },
    initDetail: function () {
      let backparams = this.$route.params.backparams
      let donationNumber = backparams.donationNumber
      if (donationNumber !== null) {
        this.donateSelect(this.donateList[0])
        this.donationNumberDetail.mvalue = donationNumber
        this.checkInputVaild(this.donationNumberDetail)
      } else {
        this.companyDetail.mvalue = backparams.company.mvalue
        this.nameDetail.mvalue = backparams.name.mvalue
        this.phoneDetail.mvalue = backparams.phoneNumber.mvalue
        this.phoneAddressDetail.mvalue = backparams.phoneAddress.mvalue
        this.addressDetail.mvalue = backparams.address.mvalue
      }
    },
    initBackParams: function () {
      if (this.$route.params.backparams === undefined || this.$route.params.backparams === null) {
        return
      }
      this.initMoneyParams()
      this.initReceipt()
      this.initDetail()
    }
  },
  computed: {
    moneyClass () {
      return function (item) {
        if (item.isSelect == null) {
          return 'content_money_unselect'
        }
        if (item.isSelect) {
          return 'content_money_select'
        } else {
          return 'content_money_unselect'
        }
      }
    },
    itemNameClass () {
      return function (item) {
        if (item.isSelect == null) {
          return 'content_money_unselect'
        }
        if (item.isSelect) {
          return 'content_money_select'
        } else {
          return 'content_money_unselect'
        }
      }
    },
    isNewDonate () {
      if (this.currentDonate == null) {
        return true
      }
      return this.currentDonate.value === 1
    },
    email: {
      get: function () {
        return this.phoneAddressDetail.mvalue
      },
      set: function (val) {
        this.phoneAddressDetail.mvalue = val.toLowerCase()
      }
    }
  },
  watch: {
    customMoney: function (newData, oldData) {
      if (this.currentMoney != null && newData != null) {
        // 若输入金额则取消之前选择
        if (this.lastSelectMoneyItem != null) {
          this.lastSelectMoneyItem.isSelect = false
        }
        this.lastSelectMoneyItem = null
        this.currentMoney = null
      }
      if (newData > 500000) {
        this.customMoney = oldData
        this.isShowCustomMoneyTip2 = true
      }
    },
    currentSelectTranlate: function (newData, oldData) {
      console.log('翻译出发发发', newData)
      if (newData === 'zh_TW') {
        this.translateToZh()
      } else {
        this.translateToEn()
      }
    }
  },
  mounted () {
    this.updateCurrentLang()
    this.translate()
    this.currentDonate = this.donateList[0] // 默认选是
    this.initBackParams()
    this.name = this.$cookies.get('name')
  }
}
</script>

<style lang="scss">
  .header{
    display: flex;
    justify-content: space-around;
  }
  .top{
    display: flex;
    justify-content: flex-end;
    flex-direction: column;
  }
  .header_item{

  }
  .content_next_item_text {
    font-size: 1em;
    color: white;
    display: block;
    padding: 6px;
  }
  .content_money_unselect{
    border: 1px solid transparent;
    background-color: rgb(239,202,203);
    border-radius: 50px;
    padding: 10px 25px;
    cursor: pointer;
  }
  .content_money_select{
    border: 1px solid transparent;
    background-color: rgb(224, 95, 64);
    color: white;
    border-radius: 50px;
    padding: 10px 25px;
    cursor: pointer;
  }
  .content_item_list {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    margin-left: 20px;
  }
  .content_quota_list{
    display: flex;
    justify-content: flex-start;
  }
  .input_item{
    height: 40px;
    padding: 10px;
  }
  .input_error{
    border: 1px solid red;
  }
  .input_noerror{
    border: 1px solid grey;
  }
  .block_tip_detail{
    margin-top: 20px;
  }
  .input_overseas{
    border: 1px solid rgb(91,155, 213);
  }
  .tip_overseas{
    color: rgb(91,155, 213);
    font-weight: bold;
  }
  .tip_mustfill {
    color: rgb(224, 95, 64);
    font-weight: bold;
  }

  @media only screen and (min-width: 900px){
    .content_next_item_text {
      font-size: 1em; /*no*/
      color: white;
      display: block;
      padding: 6px; /*no*/
    }
    .content_money_unselect{
      border: 1px solid transparent;
      background-color: rgb(239,202,203);
      border-radius: 50px; /*no*/
      padding: 10px 25px; /*no*/
      cursor: pointer;
    }
    .content_money_select{
      border: 1px solid transparent; /*no*/
      background-color: rgb(224, 95, 64);
      color: white;
      border-radius: 50px; /*no*/
      padding: 10px 25px; /*no*/
      cursor: pointer;
    }
    .content_item_list {
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
      margin-left: 20px /*no*/
    }
    .input_item{
      height: 30px; /*no*/
      padding: 6px; /*no*/
    }
    .input_error{
      border: 1px solid red; /*no*/
    }
    .input_noerror{
      border: 1px solid grey; /*no*/
    }
    $text: green;
    .block_tip_detail{
      margin-top: 20px; /*no*/
      color: $text
    }
    .input_overseas{
      border: 1px solid rgb(91,155, 213); /*no*/
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/DonationIndex.vue